import { Component } from '@angular/core';
import { ContainerWorkflowDialogContent, DataCheck } from '../../../workflow.dialog';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { ABaseContainerSettingsData } from '../container.chooser';

@Component({
    selector: 'wf-execute-clear-settings',
    templateUrl: './execute.clear.settings.html'
})
export class ExecuteClearSettings extends ContainerWorkflowDialogContent {
    Data = new ExecuteClearSettingsData();
    DBUsages = [[8192, 32]]; // RelationalWrite oder DocumentStoreWrite

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'executeClearWFModule';
        reg.Caption = '@@Clear';
        reg.GroupID = 'containeroperations';
        reg.Index = 35;
        reg.SettingsControl = ExecuteClearSettings;
        reg.SettingsTypeHelper = new ExecuteClearSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, ExecuteClearSettingsData);
        }
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        if (!this.Data.ContainerTable) {
            retVal.IsCorrect = false;
            retVal.Error = '@@Bitte waehlen Sie eine Tabelle und definieren Sie einen Filter';
        }
        return retVal;
    }

    getResult(): any {
        if (this.Data.InteractiveProperties) {
            this.Data.InteractiveProperties = this.Data.InteractiveProperties.filter(x => x.Value);
        }
        return this.Data;
    }
} 

export class ExecuteClearSettingsData extends ABaseContainerSettingsData {
}

export class ExecuteClearSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new ExecuteClearSettingsData();
    }
}